(function () {
	'use strict';

	a3_cabin_reports.factory('CampaignFactory', CampaignFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CampaignFactory
    * @description 
    *   Add, Update, Delete and Get Campaigns.
    * @ngInject
    */
	function CampaignFactory(GenericService, FlightFactory) {

		var objType = 'Campaigns';
		var objCallback = Campaign;

        /**
         * Initialize the Campaign
         * @memberof CampaignFactory
         */
		function Campaign() {
			this.GetId = GetId;
		}

		var service = {
			giftStatusList: giftStatusList,
			getFlightsCampaignsFromStorage: getFlightsCampaignsFromStorage,
			getCampaignsByFlightId: getCampaignsByFlightId,
			saveFlightCampaignsToStorage: saveFlightCampaignsToStorage,
			updateCampaignPassenger: updateCampaignPassenger,
			updateSeatNoPaxAssignments: updateSeatNoPaxAssignments,
			getPaxAssignmentsFromStorage: getPaxAssignmentsFromStorage,
			mergeCampaigns: mergeCampaigns,
			getPaxAssignment: getPaxAssignment,
			hasPendingFeedbacks: hasPendingFeedbacks,
			syncResultFormat: syncResultFormat,
			cleanOldCampaigns: cleanOldCampaigns
		};

		//Object Functions
        /**
         * Overide default get Id
         * @memberof FlightFactory
         * @returns {number} Id 
         */
		function GetId() {
			return this.FlightId;
		}

		/**
	   * Get Campaigns
	   * @memberof CampaignFactory
	   * @param {function} callback  
	   */
		function getFlightsCampaignsFromStorage() {
			return GenericService.list(objType, objCallback);
		};

        /**
         * Save Campaigns to storage
         * @memberof CampaignFactory
         * @param {Array} flightCampaigns A list of flightCampaigns
         */
		 function setFlightCampaignsToStorage(flightCampaigns) {
			GenericService.saveAll(flightCampaigns,objType,objCallback);
		}
    
		/**
		* Get single flight Campaigns
		* @memberof CampaignFactory
		* @param {function} callback  
		*/
		function getCampaignsByFlightId(flightId) {
			return GenericService.get(flightId, objType, objCallback);
		};

		/**
		* Set single flight Campaigns
		* @memberof CampaignFactory
		* @param {function} callback  
		*/
		function addFlightCampaigns(FlightCampaigns) {
			FlightCampaigns.IsFeedbackReady = !hasPendingFeedbacks(FlightCampaigns);
			return GenericService.add(FlightCampaigns, objType, objCallback);
		};


		/**
		* Get assignments from storage
		* @memberof CampaignFactory
		* @param {function} callback  
		*/
		function getPaxAssignmentsFromStorage() {
			var assignmentsToSend = [];
			var data = getFlightsCampaignsFromStorage();

			if (data) {
				var flightsReadyList = data.filter(function (d) { return d.IsFeedbackReady });

				for (let flight of flightsReadyList) {

					var flightStored = FlightFactory.getFlightFromStorage(flight.FlightId);
					var isSyncTimeValid = flightStored == null || moment().valueOf() > moment.utc(flightStored.ScheduledDeparture).valueOf();

					if (isSyncTimeValid) {
						flight.CampaignsList.forEach(function (camp) {
							camp.Treatments.forEach(function (treat) {
								treat.Assignments.forEach(function (assign) {
									var assignToSend = { ...assign, Status: +assign.StatusStr }
									assignmentsToSend.push(assignToSend);
								});
							});
						});
					}
					// else{
					//     clearFlightCampaignsFromStorage(flight.FlightId)
					// }
				}

				return {
					FlightsToFetch: data.map(function (flt) { return flt.FlightId }),
					AssignmentsToUpdate: assignmentsToSend
				};
			}
		};

		/**
		* Get assignment from storage with flightId, PNR, UCI
		* @memberof CampaignFactory
		* @param {function} callback  
		*/
		function getPaxAssignment(flightId, pnr, uci) {
			var fltCampaigns = getCampaignsByFlightId(flightId);

			var data = {
				campaign: null,
				treatment: null,
				assignment: null
			};

			if (fltCampaigns) {

				for (let camp of fltCampaigns.CampaignsList) {

					data.campaign = { title: camp.CampaignTitle, briefings: camp.Briefings };

					for (let treat of camp.Treatments) {
						data.treatment = { title: treat.Title, description: treat.Description, briefings: treat.Briefings };
						data.assignment = treat.Assignments.find(function (a) { return a.UCI == uci && a.PNR == pnr });

						if (data.assignment) break;
					}

					if (data.assignment) break;
				}
			}

			return data;
		}

		function mergeCampaigns(data) {

			//Current flights to store
			var flightIdList = getFlightsCampaignsFromStorage().map(function (x) { return x.FlightId });

			if (data.UpdateAssignmentsSuccess) {
				var incomingfltIds = data.FlightsCampaigns.map(function (x) { return x.FlightId });
				flightIdList.forEach(function (id) {
					if (!incomingfltIds.includes(id)) {
						clearFlightCampaignsFromStorage(id);
					}
				});
			}

			if (data.GetAssignmentsSuccess) {
				updateIncomingStore(data.FlightsCampaigns);

				data.FlightsCampaigns.forEach(function (flight) {
					//curent store not include incoming flight
					if (!flightIdList.includes(flight.FlightId))
						addFlightCampaigns(flight);
					//current store include flight	
					else
						saveFlightCampaignsToStorage(flight);
				});
			}
		}

		function updateIncomingStore(incomingCamps) {
			for (let flt of incomingCamps) {
				for (let camp of flt.CampaignsList) {
					for (let treat of camp.Treatments) {
						for (let assign of treat.Assignments) {
							var currentAssignment = findCurrentAssignment(assign);

							if (currentAssignment) { //&& ((assign.AutoSet && !currentAssignment.AutoSet) || (!assign.AutoSet && !currentAssignment.AutoSet))) {
								assign.Status = currentAssignment.Status;
								assign.StatusStr = currentAssignment.StatusStr;
								assign.Rate = currentAssignment.Rate;
								assign.Comments = currentAssignment.Comments;
								//assign.AutoSet = currentAssignment.Status != 5 ? false : currentAssignment.AutoSet;
							}

						}
					}
				}
			}
		}

		function findCurrentAssignment(assignment) {
			var currentCamps = getFlightsCampaignsFromStorage();
			var currentAssignment;

			for (let flt of currentCamps) {
				for (let camp of flt.CampaignsList) {
					for (let treat of camp.Treatments) {

						currentAssignment = treat.Assignments.find(function (assign) { return assign.Id == assignment.Id });
						if (currentAssignment) break;
					}
					if (currentAssignment) break;
				}
				if (currentAssignment) break;
			}

			return currentAssignment;
		}

		/**
		 * Update FlightCampaigns to Storage
		 * @memberof CampaignFactory
		 * @param {object} CampaignPassenger a CampaignPassenger
		 */
		function saveFlightCampaignsToStorage(campaignPassenger) {
			campaignPassenger.IsFeedbackReady = !hasPendingFeedbacks(campaignPassenger);
			GenericService.save(campaignPassenger, objType, objCallback);
		};

		function updateCampaignPassenger(flightId, assignment) {

			var data = getCampaignsByFlightId(flightId);
			var assignmentLs;

			if (data) {

				var fltCampaings = { ...data };

				for (let camp of fltCampaings.CampaignsList) {
					for (let treat of camp.Treatments) {

						assignmentLs = treat.Assignments.find(function (a) { return a.Id == assignment.Id });

						if (assignmentLs) {
							assignmentLs.Status = +assignment.StatusStr;
							assignmentLs.StatusStr = assignment.StatusStr;
							assignmentLs.Rate = +assignment.StatusStr == 1 ? assignment.Rate : 0;
							assignmentLs.Comments = assignment.Comments;
							//delete assignmentLs["AutoSet"];
							break;
						}
					}

					if (assignmentLs) break;
				}

				saveFlightCampaignsToStorage(fltCampaings);
			}
		}

		function updateSeatNoPaxAssignments(fltCampaings, paxinfoList) {

			fltCampaings.forEach(function (fltcamp) {
				fltcamp.CampaignsList.forEach(function (camp) {
					var paxinfo = paxinfoList.find(function (p) { return p.FlightId == fltcamp.FlightId });
					if (paxinfo) {

						var paxinfoFlatten = flatten(paxinfo.Seatmap.map(function (s) { return s.Columns }));

						camp.Treatments.forEach(function (treat) {
							treat.Assignments.forEach(function (assign) {
								var pax = paxinfoFlatten.find(function (s) { return s.PNR == assign.PNR && s.UCI == assign.UCI });
								if (pax) {
									assign.SeatNo = pax.SeatNo;
								}
								// else {
								// 	assign.Status = 5;
								// 	assign.AutoSet = true;
								// 	assign.StatusStr = '5';
								// 	assign.Comments = null;
								// 	assign.Rate = 0;
								// }
							});
						});
					}
				})
			});
		}

		function giftStatusList() {
			return [
				{ label: "-select one-", value: "0" },
				{ label: "Delivered", value: "1" },
				{ label: "Not delivered", value: "2" },
				{ label: "Damaged", value: "3" },
				{ label: "Not available", value: "4" },
				{ label: "No show", value: "5" },
				{ label: "No interest", value: "7" }];
		}

		/**
		 * Remove fligthcampaigns from the local storage
		 * @memberof CampaignFactory
		 */
		function clearFlightCampaignsFromStorage(flightId) {
			GenericService.remove(flightId, objType, objCallback);
		}

		function hasPendingFeedbacks(data) {
			var feedbackReadyCounter = 0;
			//var data = getCampaignsByFlightId(flightId);
			if (data) {
				for (let camp of data.CampaignsList) {
					for (let treat of camp.Treatments) {
						feedbackReadyCounter += treat.Assignments.filter(function (a) { return a.Status > 0 }).length;
					}
				}
			}
			return !(data.AssignmentsCounter == feedbackReadyCounter);
		}

		function syncResultFormat(result) {
			var updateText;
			var upClass;
			var fetchText;
			var fetchClass;

			if (result.UpdateAssignmentsSuccess == null) {
				updateText = "No Campaigns Feedbacks were uploaded to the server. ";
				upClass = "alert-cyan";
			} else if (result.UpdateAssignmentsSuccess == true) {
				updateText = "Campaigns Feedbacks were uploaded to the server. ";
				upClass = "alert-cyan";
			} else {
				updateText = "Campaigns Feedbacks failed to be uploaded to the server. ";
				upClass = "alert-deep-orange";
			}

			if (result.GetAssignmentsSuccess == false) {
				fetchText = "Campaigns Feedbacks failed to be fetched by the server.";
				fetchClass = "alert-deep-orange";
			} else if (result.GetAssignmentsSuccess == true && result.FlightsCampaigns.length > 0) {
				fetchText = "Campaigns Feedbacks were fetched by the server.";
				fetchClass = "alert-cyan";
			} else {
				fetchText = "No Campaigns Feedbacks were fetched by the server.";
				fetchClass = "alert-cyan";
			}

			return {
				updMessage: updateText,
				updClass: upClass,
				ftcMessage: fetchText,
				ftcClass: fetchClass
			}
		}

		function flatten(arr) {
			return arr.reduce(function (flat, toFlatten) {
				return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
			}, []);
		}

		/**
         * Clean Old Data
         * @memberof CampaignFactory
         * @param {Array} pendingFlightIds FlightIds with pending reports
         */
		function cleanOldCampaigns(pendingFlightIds) {
			var now = moment();
			getFlightsCampaignsFromStorage(function(campaigns){
				var pendingCampaigns = campaigns.FlightsCampaigns.filter(function(item){
					return pendingFlightIds.includes(item.FlightId);
				});
				// keep only the campaigns with pending reports
				setFlightCampaignsToStorage(pendingCampaigns);			
			})
		}

		return service;
	}
})();